<template>
  <div class="width-100">
    <h2 class="section-title">{{ $t('monitoringDashboard.title') }}</h2>
    <router-view :key="$route.name" />
  </div>
</template>

<script>
  export default {
    name: 'MonitoringDashboard',
  };
</script>
